

































import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import CategoryViewModel from "@models/categoryViewModel";
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { PROMOCODE_CREATE, PROMOCODE_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import PromocodeFilterModel from "@models/promocodes/promocodeFilterModel";

@Component
export default class PagePromocodesComponent extends Vue {
  @Inject('eventBus') eventBus: EventBus;
  filter: PromocodeFilterModel = new PromocodeFilterModel();
  columnNames = [ 
    '#',
    'Коды',
    'Кол-во дней',
    'Срок действия',
    '',
    ''
  ];
  createRouteName = PROMOCODE_CREATE;
  editRouteName = PROMOCODE_EDIT;
  categories: CategoryViewModel[] = [];
  getDataFunc = this.$api.PromoCodeService.getListAsync.bind(this.$api.PromoCodeService);
  removeFunc = this.$api.PromoCodeService.deleteAsync.bind(this.$api.PromoCodeService);
  async created() {  }
  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({id: item.Id});
  }
}
